import { RECEIVE_COUNTRY_LIST, SET_SELECTED_COUNTRY } from './Actions';
import getCountryParam from '../../../Utils/getCountryParam';

const initialState = {
  countries: [],
  selectedCountry: getCountryParam(),
  selectedLanguage: null,
};

const updateCountryAndLanguage = (countries, selectedCountry) => {
  const selectedLanguage = countries.find(({ identifier }) => identifier === selectedCountry).language;
  return {
    selectedCountry,
    selectedLanguage,
  };
};

export default function CountryReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_COUNTRY_LIST: {
      const countries = action.data;
      return {
        ...state,
        countries,
        ...updateCountryAndLanguage(countries, state.selectedCountry),
      };
    }
    case SET_SELECTED_COUNTRY: {
      const selectedCountry = action.data;
      return {
        ...state,
        ...updateCountryAndLanguage(state.countries, selectedCountry),
      };
    }
    default:
      return state;
  }
}
